"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weekdayLabelForDateKey = exports.pacificDateString = exports.pacificDateHourKey = void 0;
const PACIFIC_TIME_ZONE = 'America/Los_Angeles';
/**
 * Pacific calendar date + hour for an instant — the CONSUMER half of the rollup key.
 *
 * Every hourly aggregation Lambda writes its `SensorUsageRollup` rows keyed by Pacific
 * date + Pacific hour (`infrastructure/src/functions/utils/pacificTime.ts`), whatever
 * timezone the hub or the phone is in. Any lookup that builds its key some other way
 * misses by the offset and falls through to the chart's empty slot: `toISOString()`
 * missed local hours 17-23 on a Pacific device, and device-local time misses all 24
 * hours on an Eastern one.
 *
 * `hourCycle: 'h23'` is load-bearing — the `hour12: false` spelling resolves to the h24
 * cycle on some ICU builds and renders midnight as hour `'24'`. The `% 24` is a second
 * line of defence for builds that ignore `hourCycle`. Mirrors the producer helper
 * exactly; keep the two in step.
 */
const pacificDateHourKey = (instant) => {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: PACIFIC_TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(instant);
    const valueOf = (type) => parts.find((part) => part.type === type)?.value ?? '';
    return {
        date: `${valueOf('year')}-${valueOf('month')}-${valueOf('day')}`,
        hour: parseInt(valueOf('hour'), 10) % 24,
    };
};
exports.pacificDateHourKey = pacificDateHourKey;
/** Pacific calendar date (`YYYY-MM-DD`) for an instant — the rollup row's `date` field. */
const pacificDateString = (instant) => (0, exports.pacificDateHourKey)(instant).date;
exports.pacificDateString = pacificDateString;
/**
 * Short weekday label for a rollup date key. Parsed at noon so the label can never slip a
 * day on a DST boundary, and derived from the SAME string the lookup keys on, so a chart
 * column and the bucket it reads always agree.
 */
const weekdayLabelForDateKey = (dateKey) => new Date(`${dateKey}T12:00:00`).toLocaleDateString('en-US', { weekday: 'short' });
exports.weekdayLabelForDateKey = weekdayLabelForDateKey;
